import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { projectSchedulesDeleteFormSchema } from "@/schemas/projectSchedulesDeleteForm";
import { ProjectSchedulesDeleteFormData } from "@/types/projectSchedulesDeleteForm";

interface UseProjectScheduleDeleteFormOptions {
  dateStart: string;
  dateEnd: string;
  disabled?: boolean;
}

export const useProjectSchedulesDeleteForm = ({
  dateStart,
  dateEnd,
  disabled = false,
}: UseProjectScheduleDeleteFormOptions) => {
  const defaultValues = useMemo(
    () => ({
      date_start: dateStart,
      date_end: dateEnd,
      delete_all: false,
    }),
    [dateEnd, dateStart],
  );

  const form = useForm<ProjectSchedulesDeleteFormData>({
    resolver: zodResolver(projectSchedulesDeleteFormSchema),
    defaultValues,
    disabled,
  });

  return {
    form,
    defaultValues,
  };
};
